import React, { useState, useContext } from 'react'
import './registration.css'
import { handleRedirectInternal } from '../../product/common/components'
import PrimaryButton from '../../product/components/atoms/PrimaryButton'
import { useHistory, Link } from 'react-router-dom'
import { LOGO } from '../../Utils'

const RegistrationView = () => {
    const history = useHistory()
    const [currentRegistrationType, setCurrentRegistrationType] = useState(false)

    const registrationTypes = [
        {
            name: 'regType',
            label: 'Individual',
            id: 'individual',
            img: './assets/svg/individual.svg',
            url: 'register/individual',
        },
        {
            name: 'regType',
            label: 'Entity',
            id: 'company',
            img: './assets/svg/company.svg',
            url: 'register/entity',
        },
    ]

    return (
        <>
            <div className="viewPort logRegPort regViewPort usrTypeSlct">
                <div className="leftWrapper p-5 d-flex flex-column align-items-center justify-content-center">
                    <h3 className="text-center mnTxt">Registration</h3>
                    <h4 className="text-center ttlTxt m-0">Welcome to SongVest</h4>
                    <p className="text-center infoLn">Please select user type</p>
                    <div className="d-flex align-items-center my-5 typRadBtn">
                        {registrationTypes.map((data, index) => (
                            <div
                                className="regType"
                                onClick={() => setCurrentRegistrationType(data.url)}
                                key={index}
                            >
                                <input type="radio" name={data.name} hidden id={data.id} />
                                <label htmlFor={data.id}>
                                    <img src={data.img} alt="" />
                                </label>
                                <h5>{data.label}</h5>
                            </div>
                        ))}
                    </div>
                    <PrimaryButton
                        label={'Continue'}
                        disabled={!currentRegistrationType}
                        onClick={() => handleRedirectInternal(history, currentRegistrationType)}
                    />
                </div>
                <div className="rightWrapper p-5 text-right">
                    <Link to="/">
                        <img className="frmLogo" src={LOGO} height="55" />
                    </Link>
                </div>
            </div>
        </>
    )
}

export default RegistrationView
